import React from 'react';
import { Outlet } from 'react-router-dom';

const RequestHome = () => (
  <section className="app-route">
    <Outlet />
  </section>
);

export default RequestHome;